import React, { Component } from "react";
import "./Login.css";
import CircularProgress from "@material-ui/core/CircularProgress";

import {
    isAuthenticatedSelector,
    tokenSelector,
} from "../../redux/selectors/auth";
import {
    authLogin,
} from "../../redux/actions/auth";
import withShipment from "../../withShipment";
import ErrorFeedbackBar from "../../components/global/ErrorFeedbackBar";

const beenexaLogo = `${process.env.PUBLIC_URL}/logo192.png`;

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: "",
            password: "",
            showPassword: false,
            error: false,
            loading: false,
        };
    }

    handle = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value, error: false });
    };

    togglePassword = () => {
        this.setState((s) => ({ showPassword: !s.showPassword }));
    };

    handleLogin = (event) => {
        event.preventDefault();
        if (!this.state.username.trim() || !this.state.password) {
            this.setState({ error: true });
            return;
        }
        this.setState({ loading: true, error: false });
        this.props.authLogin(this.state.username, this.state.password, this.props.history);

        setTimeout(() => {
            if (!this.props.isAuthenticated) {
                this.setState({ error: true, loading: false });
            }
        }, 3000);
    };

    render() {
        const { username, password, showPassword, error, loading } = this.state;
        const canSubmit = username.trim().length > 0 && password.length > 0 && !loading;
        const year = new Date().getFullYear();
        return (
            <div className="bnxa-login-page">
                <ErrorFeedbackBar />

                {/* Branding panel — visible on tablet+ */}
                <aside className="bnxa-login-brand-panel" aria-hidden="true">
                    <div className="bnxa-login-brand-decor bnxa-decor-1" />
                    <div className="bnxa-login-brand-decor bnxa-decor-2" />
                    <div className="bnxa-login-brand-decor bnxa-decor-3" />
                    <div className="bnxa-login-brand-content">
                        <div className="bnxa-login-brand-logo-wrap">
                            <img src={beenexaLogo} alt="" className="bnxa-login-brand-logo" />
                        </div>
                        <h1 className="bnxa-login-brand-title">BeeNexa</h1>
                        <p className="bnxa-login-brand-tagline">Business management, simplified.</p>
                        <ul className="bnxa-login-brand-points">
                            <li><span className="bnxa-login-tick" aria-hidden="true">&#10003;</span> Files, accounting, and loans in one place</li>
                            <li><span className="bnxa-login-tick" aria-hidden="true">&#10003;</span> Track investors, contractors, and expenses</li>
                            <li><span className="bnxa-login-tick" aria-hidden="true">&#10003;</span> Built for teams that work on the go</li>
                        </ul>
                    </div>
                    <div className="bnxa-login-brand-footer">© {year} BeeNexa</div>
                </aside>

                {/* Form panel */}
                <main className="bnxa-login-form-panel">
                    <form className="bnxa-login-card" onSubmit={this.handleLogin} noValidate>
                        <div className="bnxa-login-card-brand">
                            <div className="bnxa-login-card-logo-wrap">
                                <img src={beenexaLogo} alt="" className="bnxa-login-card-logo" />
                            </div>
                            <h1 className="bnxa-login-card-name">BeeNexa</h1>
                        </div>

                        <label className="bnxa-login-field">
                            <span className="bnxa-login-label">Email</span>
                            <div className="bnxa-login-input-wrap">
                                <svg className="bnxa-login-input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                    <polyline points="22,6 12,13 2,6" />
                                </svg>
                                <input
                                    name="username"
                                    type="email"
                                    autoComplete="username"
                                    value={username}
                                    onChange={this.handle}
                                    placeholder="you@example.com"
                                    className="bnxa-login-input"
                                    disabled={loading}
                                />
                            </div>
                        </label>

                        <label className="bnxa-login-field">
                            <span className="bnxa-login-label">Password</span>
                            <div className="bnxa-login-input-wrap">
                                <svg className="bnxa-login-input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                </svg>
                                <input
                                    name="password"
                                    type={showPassword ? "text" : "password"}
                                    autoComplete="current-password"
                                    value={password}
                                    onChange={this.handle}
                                    placeholder="Enter your password"
                                    className="bnxa-login-input bnxa-login-input-password"
                                    disabled={loading}
                                />
                                <button
                                    type="button"
                                    className="bnxa-login-eye"
                                    onClick={this.togglePassword}
                                    aria-label={showPassword ? "Hide password" : "Show password"}
                                    tabIndex={-1}
                                >
                                    {showPassword ? (
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                                            <line x1="1" y1="1" x2="23" y2="23" />
                                        </svg>
                                    ) : (
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                            <circle cx="12" cy="12" r="3" />
                                        </svg>
                                    )}
                                </button>
                            </div>
                        </label>

                        {error && (
                            <div className="bnxa-login-error" role="alert">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                    <circle cx="12" cy="12" r="10" />
                                    <line x1="12" y1="8" x2="12" y2="12" />
                                    <line x1="12" y1="16" x2="12.01" y2="16" />
                                </svg>
                                <span>Email and password don't match. Please try again.</span>
                            </div>
                        )}

                        <button
                            type="submit"
                            className="bnxa-login-submit"
                            disabled={!canSubmit}
                            onClick={this.handleLogin}
                        >
                            {loading ? (
                                <span className="bnxa-login-submit-loading">
                                    <CircularProgress size={20} thickness={4} style={{ color: "#ffffff" }} />
                                    <span>Signing in…</span>
                                </span>
                            ) : (
                                <>Sign in</>
                            )}
                        </button>

                    </form>
                </main>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    isAuthenticated: isAuthenticatedSelector(state),
    token: tokenSelector(state),
});

const actionCreators = {
    authLogin,
};

export default withShipment({
    mapStateToProps,
    actionCreators,
}, Login);
